<div class="group-layout">
    <div class="group-box" [class.clickable]="supportsEdit()" [class.disabled]="disabled()" (click)="onEditClicked()">
        <app-layout-container fluid>
            <app-layout-row>
                <app-layout-column [width]="12">
                    <div class="group-header">
                        <p>{{title()}}</p>
                        @if (required() && supportsEdit()) {
                            <div class="required">*</div>
                        }
                        @if (supportsEdit()) {
                            <app-link iconClass="dx-icon-edit" [disabled]="disabled()">Edit</app-link>
                        }
                    </div>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="12">
                    <ng-content></ng-content>
                </app-layout-column>
            </app-layout-row>
        </app-layout-container>
    </div>

    @if (isValid() === false) {
        <div class="validation-text">
            <p>{{validationText()}}</p>
        </div>
    }
</div>
